import React from "react";

import { makeStyles } from "@material-ui/core/styles";
import { getTokens } from "../../styles/tokens";

const useStyles = makeStyles(theme => {
	const t = getTokens(theme.palette.type, theme.palette.primary.main);
	return {
		contactsHeader: {
			display: "flex",
			alignItems: "flex-end",
			flexWrap: "wrap",
			columnGap: theme.spacing(2),
			rowGap: theme.spacing(1.5),
			padding: "2px 0 22px",
			minWidth: 0,
			position: "relative",
			color: t.text,
			// título à esquerda; qualquer wrapper de ações vai para a direita
			"& > :first-child": {
				minWidth: 0,
			},
			[theme.breakpoints.down("xs")]: {
				alignItems: "stretch",
				padding: "0 0 16px",
			},
		},
	};
});

/**
 * Linha de cabeçalho de página: título à esquerda, ações à direita
 * (via MainHeaderButtonsWrapper). Sem borda; espaçamento compacto e responsivo.
 */
const MainHeader = ({ children, className }) => {
	const classes = useStyles();

	return (
		<div
			className={[classes.contactsHeader, "kp-page-header", className]
				.filter(Boolean)
				.join(" ")}
		>
			{children}
		</div>
	);
};

export default MainHeader;
